export const Regex = {
  email:
    /^[a-zA-Z0-9][-a-zA-Z0-9_+.]*[a-zA-Z0-9]@[a-zA-Z0-9][-a-zA-Z0-9.]*[a-zA-Z0-9]\.[a-zA-Z]{2,16}$/i,
  onlyNumber: /^\d+$/,
  hasNumber: /\d/,
  zipLength: /^.{4}$/,
  notEmpty: /.+/,
  minPasswordLength: /^.{8,}$/,
  streetWithHouseNumber: /(?=.*\D)(?=.*\d)/,
  streetWithHouseNumberWithoutSpace: /^\S.*(\s{1})(\d+)/,
  password:
    /^(?=.*[a-zA-Z])(?=.*\d)(?!.*(?:passwort|password|kennwort)).{8,}$/i,
  hardPassword:
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_])(?!.*(?:passwort|Passwort|password|Password|kennwort|Kennwort)).{8,}$/,
  notMatchWithString: (str: string) => new RegExp(`^(?!.*(?:${str})).*$`),
  emailUsername: /^(.+?)@/,
  emailDomain: /(@.+?)$/,
  emailDomainWithoutAt: /@{1}/,
  domainPrefix: /(?:.*@)([^.@]+)\.[^@]+$/,
  emailPrefix: /^(.*?)(?=\d+@)/,
  tax: /^ATU[0-9]{8}$|^$/,
  slashes: /^\/|\/$/g,
  unitOfMeasurementPDPDetails: /\(([^)]+)\)/, // If the attribute name contains a unit of measurement in brackets
  zipCodes: {
    BE: /^[1-9]\d{3}$/,
    NL: /^[1-9][0-9]{3} ?(?!SA|SD|SS)[A-Z]{2}$/,
  } as { [key: string]: RegExp },
};
